module.exports = __webpack_public_path__ + "img/logo-ea.78529c51.svg";